module.exports = __webpack_public_path__ + "img/verify.1910e911.svg";